import { Controller } from "@hotwired/stimulus"

export default class BidController extends Controller {
  static targets = ["amount", "error"]

  validate(event) {
    const amount = Number.parseFloat(this.amountTarget.value)

    const highestBid = Number.parseFloat(this.amountTarget.dataset.highestBid || "0")

    if (Number.isNaN(amount)) {
      this.showError("Please enter a valid amount.")
      event.preventDefault()
      return
    }

    if (amount <= highestBid) {
      this.showError(`must be higher than (${highestBid} ETH).`)
      event.preventDefault()
      return
    }

    this.hideError()
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("d-none")
  }

  hideError() {
    this.errorTarget.classList.add("d-none")
    this.errorTarget.textContent = ""
  }
}
